export const settingsTranslationAR = {
  settings: {
    "title": "الإعدادات",
    'preferences': 'تفضيلات',
    "account": "الحساب"
  }
}